import React from "react";

export default function EditVacunaModal({ vacuna, onClose, onSave, saving }) {
  if (!vacuna) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        zIndex: 100000,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--space-4)'
      }}
      onClick={onClose}
    >
      <div
        className="card card-elevated"
        style={{ borderRadius: 'var(--radius-xl)', maxWidth: '500px', width: '100%', overflow: 'hidden' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="modal-header-gradient d-flex justify-content-between align-items-center"
          style={{ padding: 'var(--space-3) var(--space-4)' }}
        >
          <h5
            className="mb-0"
            style={{ fontSize: 'var(--font-size-lg)', fontWeight: 'var(--font-weight-bold)', color: 'var(--white)' }}
          >
            <i className="bi bi-pencil me-2"></i>
            Editar Vacuna
          </h5>
          <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
        </div>

        <div className="card-body" style={{ padding: 'var(--space-4)' }}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.target);
              onSave(vacuna.id, {
                nombre: formData.get('nombre'),
                fecha: formData.get('fecha'),
                laboratorio: formData.get('laboratorio') || null,
                lote: formData.get('lote') || null,
                caducidad: formData.get('caducidad') || null,
                proximaVacunacion: formData.get('proximaVacunacion') || null
              });
            }}
          >
            <div className="mb-3">
              <label className="form-label" style={{ fontSize: 'var(--font-size-sm)', fontWeight: '500' }}>
                Nombre de la vacuna *
              </label>
              <input type="text" className="form-control" name="nombre" defaultValue={vacuna.nombre} required style={{ fontSize: 'var(--font-size-sm)' }} />
            </div>

            <div className="mb-3">
              <label className="form-label" style={{ fontSize: 'var(--font-size-sm)', fontWeight: '500' }}>
                Fecha de aplicación *
              </label>
              <input type="date" className="form-control" name="fecha" defaultValue={vacuna.fecha} required style={{ fontSize: 'var(--font-size-sm)' }} />
            </div>

            <div className="mb-3">
              <label className="form-label" style={{ fontSize: 'var(--font-size-sm)', fontWeight: '500' }}>
                Laboratorio
              </label>
              <input type="text" className="form-control" name="laboratorio" defaultValue={vacuna.laboratorio || ''} placeholder="Ej: Zoetis, MSD, Virbac..." style={{ fontSize: 'var(--font-size-sm)' }} />
            </div>

            <div className="row">
              <div className="col-6 mb-3">
                <label className="form-label" style={{ fontSize: 'var(--font-size-sm)', fontWeight: '500' }}>
                  Número de lote
                </label>
                <input type="text" className="form-control" name="lote" defaultValue={vacuna.lote || ''} style={{ fontSize: 'var(--font-size-sm)' }} />
              </div>
              <div className="col-6 mb-3">
                <label className="form-label" style={{ fontSize: 'var(--font-size-sm)', fontWeight: '500' }}>
                  Fecha de caducidad
                </label>
                <input type="date" className="form-control" name="caducidad" defaultValue={vacuna.caducidad || ''} style={{ fontSize: 'var(--font-size-sm)' }} />
              </div>
            </div>

            <div className="mb-4">
              <label className="form-label" style={{ fontSize: 'var(--font-size-sm)', fontWeight: '500' }}>
                Próxima vacunación
              </label>
              <input type="date" className="form-control" name="proximaVacunacion" defaultValue={vacuna.proximaVacunacion || ''} style={{ fontSize: 'var(--font-size-sm)' }} />
            </div>

            <div className="d-flex gap-2 justify-content-end">
              <button type="button" className="btn btn-outline-secondary" onClick={onClose} disabled={saving} style={{ fontSize: 'var(--font-size-sm)' }}>
                Cancelar
              </button>
              <button type="submit" className="btn btn-primary" disabled={saving} style={{ fontSize: 'var(--font-size-sm)' }}>
                {saving ? (
                  <><span className="spinner-border spinner-border-sm me-2" role="status"></span>Guardando...</>
                ) : (
                  <><i className="bi bi-check2 me-2"></i>Guardar cambios</>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
